<template>
  <div>
    <v-col sm="12" class="d-flex justify-end mb-2">
      <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" class="mx-1 mt-2" @click="exportExcel">
        <v-icon left>mdi-file-upload-outline</v-icon>
        Xuất Excel
      </v-btn>
      <v-btn
        v-if="
          groupInfo.category === 'custom' &&
            (($auth.policies['add-new-tuition-fee-group'] && groupInfo.type === 'normal') ||
              ($auth.policies['add-new-priority-group'] && groupInfo.type === 'priority'))
        "
        class="mx-1 mt-2"
        depressed
        dark
        color="#0D47A1"
        @click="$refs['dialog-import-excel'].openDialog()"
      >
        <v-icon left>mdi-file-download-outline</v-icon>
        Nhập Excel
      </v-btn>
      <v-btn
        v-if="
          groupInfo.category === 'custom' &&
            (($auth.policies['add-student-tuition-fee-group'] && groupInfo.type === 'normal') ||
              ($auth.policies['add-new-priority-group'] && groupInfo.type === 'priority'))
        "
        outlined
        color="#0D47A1"
        class="mx-1 mt-2"
        @click="$refs['dialog-add-student'].openDialog()"
      >
        <v-icon left>mdi-account-plus</v-icon>
        Thêm học sinh
      </v-btn>
    </v-col>
    <AddStudentDialog ref="dialog-add-student" />
    <importExcelDialog ref="dialog-import-excel" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import AddStudentDialog from '@/modules/tuitionFee/detail-group/dialogAddStudent/AddStudentDialog'
import { getHeader } from './helper/headerTable'
import utils from '@/plugins/utils'
import importExcelDialog from '@/modules/tuitionFee/detail-group/importExcelDialog/importExcelDialog.vue'
export default {
  components: {
    AddStudentDialog,
    importExcelDialog
  },
  computed: {
    ...mapGetters({
      groupInfo: 'tuitionFeeGroup/groupInfo'
    })
  },
  methods: {
    ...mapActions('tuitionFeeGroupStudent', ['fetchStudentsInGroup']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let category = this.groupInfo.category
        let header = getHeader(category)
        header.splice(0, 1)
        header.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = header.map(({ text, value }) => ({ text, value }))

        excelHeader = excelHeader.filter(excel => excel.value !== 'action' && excel.value !== 'stt')
        const list = await this.fetchStudentsInGroup({
          defaultId: this.groupInfo.defaultId,
          defaultType: this.groupInfo.defaultType,
          id: this.groupInfo.id
        })
        const students = JSON.parse(JSON.stringify(list))
        let filter = this.$options.filters
        const data = students.map(item => {
          item.code = filter.getStudentCode(item.code)
          item.status = filter.status(item.status)
          item.dob = filter.ddmmyyyy(item.dob)
          item.gender = filter.gender(item.gender)
          item.currentClass = item.currentClass && item.currentClass.title ? item.currentClass.title : ''
          return item
        })
        utils.exportExcel(
          data,
          excelHeader,
          `Danh sách học sinh nhóm ${this.getTypeGroup(this.groupInfo.type)} ${this.groupInfo.title}`
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    getTypeGroup(type) {
      switch (type) {
        case 'normal': {
          return 'chịu phí'
        }
        case 'priority': {
          return 'giảm trừ'
        }
      }
    }
  }
}
</script>
